module.exports = __webpack_public_path__ + "media/images/country_flags/ir-2bfa21894a39508db9706f5e273a33b2.png";